import React from 'react';
import classes from './CountSortingContainer.module.scss'
import CountData from "../CountData/CountData";
import SortComponent from "../../../pages/ProductCategoryPage/SortComponent/SortComponent";

const CountSortingContainer = (props) => {
    return (
        <div className={classes.CountSorting_container}>
            <CountData data={props.data} label={props.label}/>
            <span style={{gridArea: 'delimiter'}}>|</span>
            <SortComponent options={props.options}
                           onSortHandler={props.onSortHandler}
                           defaultOps={props.defaultOps}/>
        </div>
    );
}

export default CountSortingContainer;